import type {FinishedSaveResponse, UUID} from 'src/typings';
import type {ReportReferenceReported} from './types';
import type {RecordBulkEditParams} from 'src/features/record/record-bulk-edit.data-service';
import type {AjaxService} from 'core/data-services/ajax.service';
import {exists} from 'shared/utils/custom-utils';

export class ReportReferencesDataService {
    public static serviceName = 'reportReferencesDataService';

    public static readonly TOTAL_REPORTED_ROUTE = 'report-references/total-reported';

    public static readonly CREATE_FROM_FILES_ROUTE = 'records/create-from-files';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async createFondRecordsUsingFiles(files: File[], fondId: number, bulkEditParams?: RecordBulkEditParams): Promise<FinishedSaveResponse<UUID[]>> {
        const formData = new FormData();

        files.forEach((file) => formData.append('files', file));
        formData.append('fond', fondId.toString(10));

        if (exists(bulkEditParams)) {
            formData.append(
                'bulkEditRequest',
                new Blob([JSON.stringify(bulkEditParams)], {type: 'application/json'})
            );
        }

        return this.ajaxService.createRequest(ReportReferencesDataService.CREATE_FROM_FILES_ROUTE)
            .withHeaders({'Content-Type': undefined}) // Browser will set Content-Type automatically
            .post(formData);
    }

    public async getTotalReportedValues(reportReference: UUID): Promise<ReportReferenceReported> {
        return this.ajaxService
            .createRequest(ReportReferencesDataService.TOTAL_REPORTED_ROUTE)
            .get({reportReference});
    }
}